module.exports = __webpack_public_path__ + "images/press-01939b8550328b03d92adf31ec3cd370.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/press.jpg
// module id = ./client/assets/images/press.jpg
// module chunks = 86